// extracted by mini-css-extract-plugin
export var active = "_d3-2";
export var recordingDot = "_d3-1";
export var recordingIndicator = "_d3-0";